import Model from "../Model";

export default class Article extends Model {}
